import { render, staticRenderFns } from "./RoutesMap.vue?vue&type=template&id=8d913368&scoped=true&"
import script from "./RoutesMap.vue?vue&type=script&lang=js&"
export * from "./RoutesMap.vue?vue&type=script&lang=js&"
import style0 from "./RoutesMap.vue?vue&type=style&index=0&id=8d913368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d913368",
  null
  
)

export default component.exports